import React from 'react';
import { Container, Row, Table } from 'react-bootstrap';
import { RadioGroup } from '../Radio';
import SelectableCard from './SelectableCard';

const SelectableCardDemo = () => {
  const [value, setValue] = React.useState<string | number>('test-2');
  const [value1, setValue1] = React.useState<string | number>('test-2');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  const handleChange1 = (e: string | number) => {
    setValue1(e);
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Selectable Card - with optional expand</h4>
        <RadioGroup name={'test1'} value={value} onChange={handleChange}>
          <Row>
            <SelectableCard
              title="Consumer Choice HDHP"
              subtitle1="Imputed Income for tax purposes $2,250"
              subtitle2="Sign up for Health Savings Account and receive $1,000!"
              prePaydPeriod={177.24}
              prePaydPeriodSubtitle="3 persons, per-pay-period"
              radioButtonValue="1"
              selected={value === '1'}
            >
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                </tbody>
              </Table>
            </SelectableCard>
          </Row>
          <Row>
            <SelectableCard
              title="Consumer Choice HDHP"
              subtitle1="Imputed Income for tax purposes $2,250"
              prePaydPeriod={177.24}
              radioButtonValue="2"
              selected={value === '2'}
            />
          </Row>
          <Row>
            <SelectableCard
              title="Consumer Choice HDHP"
              subtitle1="Imputed Income for tax purposes $2,250"
              prePaydPeriod={177.24}
              totalSum={177.24}
              radioButtonValue="3"
              selected={value === '3'}
            ></SelectableCard>
          </Row>
        </RadioGroup>
        <RadioGroup name={'test2'} value={value} onChange={handleChange1}>
          <Row>
            <SelectableCard
              title="1 x Base Pay"
              prePaydPeriod={5.50}
              totalSum={50000}
              radioButtonValue="4"
              selected={value1 === '4'}
            />
          </Row>
          <Row>
            <SelectableCard
              title="2 x Base Pay"
              prePaydPeriod={7.00}
              totalSum={100000}
              radioButtonValue="5"
              selected={value1 === '5'}
            />
          </Row>
          <Row>
            <SelectableCard
              title="No Coverage"
              prePaydPeriod={177.24}
              radioButtonValue="6"
              disabled
              selected={value1 === '6'}
            />
          </Row>
        </RadioGroup>
      </Container>
    </Container>
  );
};

export default SelectableCardDemo;
